<template>
  <div class="error-view">
    <FontAwesomeIcon class="error-icon" :icon="faTriangleExclamation" />
    <p class="error-message">
      {{ t(`errorView.${errorType}`, { externalProjectId }) }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
  import { ErrorType } from './ErrorView.types';
  import { useI18n } from 'vue-i18n';

  defineProps<{
    errorType: ErrorType;
    externalProjectId?: string;
  }>();

  const { t } = useI18n();
</script>

<style lang="scss" scoped>
  .error-view {
    height: $main-content-height;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .error-icon {
      font-size: 10rem;
      color: $danger-color;
      margin-bottom: 3rem;
    }
    .error-message {
      font-size: 2rem;
      text-align: center;
      max-width: 600px;
    }
  }
</style>
